"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GoToFill_exports = {};
__export(GoToFill_exports, {
  default: () => GoToFill_default
});
module.exports = __toCommonJS(GoToFill_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 1.91016C5.04427 1.91016 4.65365 2.07292 4.32812 2.39844C4.0026 2.72396 3.83984 3.12109 3.83984 3.58984V9.74219H12.2188L9.73828 7.26172C9.63411 7.17057 9.58203 7.0599 9.58203 6.92969C9.58203 6.78646 9.63411 6.66276 9.73828 6.55859C9.82943 6.46745 9.9401 6.42188 10.0703 6.42188C10.2135 6.42188 10.3372 6.46745 10.4414 6.55859L13.7031 9.83984C13.8203 9.94401 13.8789 10.0807 13.8789 10.25C13.8789 10.4062 13.8203 10.543 13.7031 10.6602L10.4414 13.9219C10.3372 14.026 10.2135 14.0781 10.0703 14.0781C9.9401 14.0781 9.82943 14.026 9.73828 13.9219C9.63411 13.8307 9.58203 13.7201 9.58203 13.5898C9.58203 13.4466 9.63411 13.3229 9.73828 13.2188L12.1992 10.7578H3.83984V16.9102C3.83984 17.3789 4.0026 17.776 4.32812 18.1016C4.65365 18.4271 5.04427 18.5898 5.5 18.5898H15.5C15.9557 18.5898 16.3464 18.4271 16.6719 18.1016C16.9974 17.776 17.1602 17.3789 17.1602 16.9102V3.58984C17.1602 3.12109 16.9974 2.72396 16.6719 2.39844C16.3464 2.07292 15.9557 1.91016 15.5 1.91016H5.5Z",
      fill: "currentColor"
    }
  )
);
const SvgGoToFill = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GoToFill_default = SvgGoToFill;
